import { render, staticRenderFns } from "./EditorialHorizontalImmersive.vue?vue&type=template&id=dd0ea124&"
import script from "./EditorialHorizontalImmersive.vue?vue&type=script&lang=js&"
export * from "./EditorialHorizontalImmersive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports